import each from 'lodash/each'

import Page from '../../classes/Page'
import { app, api } from '../../utils/store'

import Maps from '../../modules/Maps.bak'

export default class ArchiveStore extends Page{
    constructor(){
        super({
            id : 'archive_store',
            element: '[data-app-page]',
            elements: {
                header: 'header',
                title: 'header .title', 
                map: '#map',
                search: '#store-search',
                results: '#results',
                counters: '[data-counter="febalcasa-store"]',
                counters_corner: '[data-counter="corner"]',
                geolocate: '#geolocate-toggler',
                button: '#search-map-btn',
                submit: '[data-main-cta]'
            },
            scroll: new URL(window.location.href).searchParams.has('location') || (new URL(window.location.href).searchParams.has('lat') && new URL(window.location.href).searchParams.has('lon')) ? app.content : window
        })
        
        this.url = new URL(window.location.href)
    }

    async create() {
        super.create()
        
        if(!(this.url.searchParams.has('location') && this.url.searchParams.get('location')!="null") && (!this.url.searchParams.has('lat') && !this.url.searchParams.has('lon'))){
            this.map = new Maps({ 
                element: this.elements.map, 
                coordinates: {
                    lat: 43.99004304490008, 
                    lng: 12.515750753970716
                },
                zoom: {
                    value: 12,
                    controls: {
                        enable: false,
                        // options: {
                        //     style: google.maps.ZoomControlStyle.SMALL,
                        //     position: google.maps.ControlPosition.RIGHT_TOP,
                        // }
                    }
                },
            });

            let markersList = new Array();

            document.querySelectorAll('.tease-store').forEach((tease) => {
                console.log(tease);
                console.log(tease.style.getPropertyValue('display'));
                if(tease.style.getPropertyValue('display')!="none"){
                    let store = {
                        'id': tease.getAttribute('data-id'),
                            'kind': 'febal-casa-store',
                            'title': tease.querySelector('.name').innerHTML,
                            'location': {
                            'address': '',
                                'lat': Number(tease.getAttribute('data-lat')),
                                'lng': Number(tease.getAttribute('data-lng'))
                        }
                    }
                    markersList.push(tease);}
            });

            // console.log(markersList)

            this.map.create({
                search: {
                    input: this.elements.search,
                    autoComplete: true,
                    geolocate: false
                },
                zoom: {
                    value: 12,
                    controls: {
                        enable: false,
                        // options: {
                        //     style: google.maps.ZoomControlStyle.SMALL,
                        //     position: google.maps.ControlPosition.RIGHT_TOP,
                        // }
                    }
                },
                markers: true,
                markersList: markersList
            })
        } else {
            app.content.style.setProperty('--header-height', `${this.elements.header.clientHeight}px`)

            await this.onReload()




            /*this.map.create({
                search: {
                    input: this.elements.search,
                    autoComplete: true,
                    geolocate: this.elements.geolocate
                },
                markers: true
            })*/
        }

        if (this.elements.button) {
            this.onSubmit(this.elements.button)
        } else if(this.elements.submit){
            this.onSubmit(this.elements.submit)
        }
    }

    onSubmit = (entry) => {
        entry.onclick = (event) => {
            event.preventDefault()
            this.data_map = this.elements.search.getAttribute('data-map')
            this.setURLSearchParam('result', 1)
            this.setURLSearchParam('location', this.data_map)
            location.reload()
        }
        this.elements.search.addEventListener("keyup", (event) => {
            if (event.keyCode === 13) {
                event.preventDefault();
                this.data_map = this.elements.search.getAttribute('data-map')
                this.setURLSearchParam('result', 1)
                this.setURLSearchParam('location', this.data_map)
                location.reload()
            }
        });
    }

    onReload = async () => {

        if(this.url.searchParams.get('lat') && this.url.searchParams.get('lon') && !this.url.searchParams.get('location')) {
            this.elements.title.insertAdjacentHTML( 'beforeend', '<br>' + this.url.searchParams.get('loc'))
            this.coordinates = {
                lat: Number(this.url.searchParams.get('lat')),
                lng: Number(this.url.searchParams.get('lon'))
            }
        } else {
            this.location = this.url.searchParams.get('location')

            let data = this.location.split("|")
            this.elements.title.insertAdjacentHTML('beforeend', '<br>' + data[2])

            this.coordinates = {
                lat: Number(data[0]),
                lng: Number(data[1])
            }
        }

        return this.domManipulation();
        //this.request()
    }

    async request(){
        //let request = await fetch(`${config.api}geolocation/stores`)
        let request = await fetch(`https://www.febalcasa.com/wp-content/uploads/json/stores.json`)

        if (request.status === 200) {
            let response = await request.json()

        }
    }

    async domManipulation(){
        let stores = new Array()
        let map_kms = new Array()
        let counter_store = 0
        let counter_corner = 0
        let km = 0;
        let markersList = new Array();


        stores = document.querySelectorAll('.tease-store, .corner');

        
        each(stores, (store) => {

            let tease = store;

            km = this.calculateDistance(
                {lat: this.coordinates.lat, lng: this.coordinates.lng}, 
                {lat: Number(tease.getAttribute('data-lat')), lng: Number(tease.getAttribute('data-lng'))})
            
            map_kms.push((km))

             //document.getElementById(`tease-${store.slug}`)

            if (tease) {
                tease.setAttribute('data-km', km)
                tease.style.setProperty('order', km.toString())
                
                
                if ((km) > 50){
                    tease.style.setProperty('display','none') 
                } else {
                    tease.querySelector('.distance .label').innerHTML = `${km}km`
                    if (tease.classList.contains('corner')) {
                        tease.querySelector('.km-title').innerHTML = `${km}km`
                        counter_corner++
                        
                    } else {
                        counter_store++

                    }
                }
            }
        });

        console.log(map_kms);

        map_kms = map_kms.sort(function (a, b) {return a - b})
        if ((counter_store == 0) && (counter_corner == 0)) {
            let item = document.querySelector('[data-km="'+map_kms[0]+'"]')
            item.style.setProperty('display','block')
            item.querySelector('.distance .label').innerHTML = `${km}km`
            if (item.classList.contains('corner')) {
                item.querySelector('.km-title').innerHTML = `${km}km`
                counter_corner++
            } else {
                counter_store++

            }
        }

        if (counter_corner == 0) {
            this.elements.counters_corner.style.setProperty('display','none')
        } else if (counter_store == 0) {
            this.elements.counters.style.setProperty('display','none')
        }

        each(stores, (store) => {
            let tease = store;
            //console.log(tease.style.getPropertyValue('display'));
            if(tease) {
                if (tease.style.getPropertyValue('display') != "none") {
                    markersList.push(store);
                }
            }
        });

        console.log(markersList);

        this.elements.counters.children[0].innerHTML = counter_store
        this.elements.counters_corner.children[0].innerHTML = counter_corner

        document.querySelector('section.result').style.setProperty('visibility','visible');

        this.map = new Maps({
            element: this.elements.map,
            zoom: {
                value: 12,
                controls: {
                    enable: false,
                    // options: {
                    //     style: google.maps.ZoomControlStyle.SMALL,
                    //     position: google.maps.ControlPosition.RIGHT_TOP,
                    // }
                }
            },
            coordinates: {
                lat: this.coordinates.lat,
                lng: this.coordinates.lng
            },
            ui: true,
            wheel: false,
            fullscreen: false,
            streetView: false,
            mapTypeControl: false,
            draggable: true,
            api: {
                namespace: 'geolocation',
                endpoint: 'available'
            }
        })

        this.map.create({
            search: {
                input: this.elements.search,
                autoComplete: true,
                geolocate: false
            },
            markers: null,
            markersList: markersList
        })
    }

    calculateDistance = (
        origin = {lat: 43.99004304490008, lng: 12.515750753970716}, 
        store = {lat: null, lng: null}
    ) => {
        if(store.lat == null || store.lng == null){
            console.error("Store missing coordinates ({lat: null, lng: null}")
            return
        } else {
            let km = 3959 * Math.acos(Math.cos(radians(origin.lat)) * Math.cos(radians(store.lat)) * Math.cos(radians(store.lng) - radians(origin.lng)) + Math.sin(radians(origin.lat)) * Math.sin(radians(store.lat))) / 0.62137
            return Math.ceil(km)
            
            function radians(degrees){ return degrees * (Math.PI/180) }
        }
    }

    setURLSearchParam = (key, value) => {
        this.url.searchParams.set(key, value)
        window.history.pushState({ path: this.url.href }, '', this.url.href)
    }
    
    addEventListeners() {
        window.addEventListener('resize', () => {
            app.content.style.setProperty('--header-height', `${this.elements.header.clientHeight}px`)
        })
    }

    destroy(){ 
        super.destroy()
    }
}